import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../hooks";
import { logOut, setMemInfo } from "../redux/authSlice";

type Auth = {
    memId: string;
    memName: string;
    memKey: string;
}

const Redirect: React.FC = () => {
    const query = new URLSearchParams(window.location.search);
    const uri = query.get("goURI");
    const sessionMemId = query.get("sessionMemId");
    const memName = query.get("tempMemName");
    const memKey = query.get("memKey");
    const dispatch = useAppDispatch();
    const member: Auth = {
        memId: '',
        memName: '',
        memKey: '',
    };
    useEffect(() => {
        if ((null !== sessionMemId && "" !== sessionMemId) && (null !== memName && "" !== memName) && (null !== memKey && "" !== memKey)) {
            member.memId = sessionMemId;
            member.memName = memName;
            member.memKey = memKey;
            dispatch(setMemInfo(member));
        } else if ((null !== sessionMemId || "" !== sessionMemId) && (null !== memName && "" !== memName) && (null !== memKey && "" !== memKey)) {
            member.memName = memName;
            member.memKey = memKey;
            dispatch(setMemInfo(member));
        } else {
            dispatch(logOut());
        }
        if (null !== uri && "" !== uri) {
            window.location.href = uri;
        } else {
            window.location.href = "/column/columnList";
        }
    }, []);
    return (
        <div>
        </div>
    )
}

export default Redirect;